import React, {Fragment, useEffect, useState} from "react";
import {Listbox, Transition} from "@headlessui/react"

export interface SuggestionFormItem {
    name: number | string,
    id: number | string
}

interface IProps {
    title?: string,
    value?: string,
    placeholder?: string,
    data: Array<SuggestionFormItem>,
    errMsg?: string,
    onChangeText?: (text: string) => void
    onSelect?: (id: any) => void
}

function SuggestionForm(props: IProps) {
    const {title, value, data, placeholder, onChangeText, onSelect, errMsg} = props
    const [keyword, setKeyword] = useState<string>(value || "")
    const [show, setShow] = useState<boolean>(false)

    useEffect(() => {
        value && setKeyword(value)
    }, [value])

    useEffect(() => {
        onChangeText && onChangeText(keyword)
    }, [keyword])

    const $errMsg = errMsg && errMsg.length ? <p className="text-red-500 text-xs italic my-1">{errMsg}</p> : null
    return (
        <div>
            {title ? <p className={"relative text-gray-1 text-sm text-left mb-1"}>{title}</p> : null}
            <div className={"relative w-full"}>
                <Listbox value={null} onChange={(id) => {
                    const item = data.find((_item) => {
                        return _item.id === id
                    })
                    if (item) {
                        setKeyword(item.name.toString())
                        onSelect && onSelect(item.id)
                    }
                    setShow(false)
                }}>
                    <div className="w-full">
                        <div className="w-full relative flex flex-row justify-between items-center h-10 rounded-md">
                            <svg className={"absolute left-2"} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.25 15C11.9779 15 15 11.9779 15 8.25C15 4.52208 11.9779 1.5 8.25 1.5C4.52208 1.5 1.5 4.52208 1.5 8.25C1.5 11.9779 4.52208 15 8.25 15Z" stroke="#14142B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M16.5 16.5L13.5 13.5" stroke="#14142B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>

                            <input onFocus={() => {
                                setShow(true)
                            }} onBlur={(event) => {
                                !event.relatedTarget && setShow(false)
                            }} value={keyword} onChange={(e) => {
                                setKeyword(e.target.value)
                            }} placeholder={placeholder} className={`flex-1 h-full text-sm font-base bg-gray-6 text-input pl-10 pr-2 rounded focus:outline-none focus:ring-4 border ${errMsg && errMsg.length ? "bg-error-20 border-error focus:border-error focus:ring-error-20" : "focus:border-theme-blue focus:ring-theme-blue-30"}`}/>

                            <div className={`absolute right-0 p-2.5 ${data && data.length > 1 ? "cursor-pointer" : "hidden"}`} onClick={() => {
                                setShow(!show)
                            }}>
                                <svg width="13" height="6" viewBox="0 0 13 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 2.25L6.51841 3.99079L3.03683 2.25" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                        </div>
                        {data.length ? (
                            <Transition
                                as={Fragment}
                                show={show}
                                enter="transition duration-100 ease-out"
                                enterFrom="transform scale-95 opacity-0"
                                enterTo="transform scale-100 opacity-100"
                                leave="transition duration-75 ease-out"
                                leaveFrom="transform scale-100 opacity-100"
                                leaveTo="transform scale-95 opacity-0"
                            >
                                <Listbox.Options className="z-30 bg-white absolute w-full py-1 mt-2 overflow-auto text-base bg-white rounded-lg shadow-2xl border max-h-60 focus:outline-none">
                                    {data.map((item, idx) => {
                                        const title = item.name
                                        return (
                                            <Listbox.Option
                                                key={idx}
                                                value={item.id}
                                                className={"px-1"}
                                            >
                                                {() => {
                                                    return (
                                                        <div
                                                            className={"rounded bg-white text-gray-1 hover:text-theme-blue font-normal w-full py-2 px-4 text-sm truncate hover:font-semibold hover:bg-theme-blue-10"}
                                                        >
                                                            {title}
                                                        </div>
                                                    )
                                                }}
                                            </Listbox.Option>
                                        )
                                    })}
                                </Listbox.Options>
                            </Transition>
                        ) : null}
                    </div>
                </Listbox>
            </div>
            {$errMsg}
        </div>
    )
}

export default SuggestionForm
